import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import cart from '../src/assets/cart.svg';

const Product_Detail = ({
  addItem,
  countingg,
  types,
  cartItems = [], // Default to empty array
  setCartItems, // Pass setCartItems
  quantities = {}, // Default to empty object
  setQuantities, // Pass setQuantities
}) => {
  const { id } = useParams();
  const [socks, setSocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [outOfStockItems, setOutOfStockItems] = useState({});
  const [successMessage, setSuccessMessage] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setLoading(true);
    axios.get('https://cottonlocalhost1365.onrender.com/api/items')
      .then(response => {
        setSocks(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
        setLoading(false);
      });
  }, []);

  const filteredProducts = socks.filter(sock => sock._id === id);

  const handleQuantityChange = (id, value) => {
    const newQuantity = Math.max(1, Math.min(20, parseInt(value) || 1));
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [id]: newQuantity,
    }));
  };

  const handleAddToCart = async (id) => {
    const quantity = quantities[id] || 1;
    const product = types.find((sock) => sock._id === id);

    if (!product) {
      alert('Product not found.');
      return;
    }

    try {
      // Fetch the current stock from the database
      const stockResponse = await axios.get(`https://cottonlocalhost1365.onrender.com/api/items/${id}`);
      const availableStock = stockResponse.data.quantity;

      // Calculate the total quantity of this item already in the cart
      const currentQuantityInCart = cartItems.find((item) => item.productId === id)?.quantity || 0;

      // Calculate the total desired quantity (current in cart + new quantity)
      const totalDesiredQuantity = currentQuantityInCart + quantity;

      // Check if the total desired quantity exceeds the available stock
      if (totalDesiredQuantity > availableStock) {
        const remainingStock = availableStock - currentQuantityInCart;
        const message =
          remainingStock < 1
            ? 'Out of stock'
            : `Only ${remainingStock} items left in stock.`;
        setOutOfStockItems((prev) => ({
          ...prev,
          [id]: message,
        }));
        setTimeout(() => {
          setOutOfStockItems((prev) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
          });
        }, 10000);
        return;
      }

      // If the item is already in the cart, update its quantity
      const existingItemIndex = cartItems.findIndex((item) => item.productId === id);
      if (existingItemIndex !== -1) {
        const updatedCartItems = [...cartItems];
        updatedCartItems[existingItemIndex].quantity += quantity;
        setCartItems(updatedCartItems);
      } else {
        // If the item is not in the cart, add it
        setCartItems((prev) => [
          ...prev,
          { productId: id, quantity: quantity },
        ]);
      }

      // Update the cart count and show success message
      countingg();
      setSuccessMessage(true);
      setTimeout(() => {
        setSuccessMessage(false);
      }, 2000);
      setOutOfStockItems((prev) => ({ ...prev, [id]: false }));
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  };

  return (
    <div className="mt-28 md:mt-0 min-h-[550px] flex flex-col justify-center items-center text-center opacity-0 animate-fade-in"
      style={{ animationDelay: `${3 * 0.1}s` }}>
      {loading ? (
        <div className="flex flex-col items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
          <p className="mt-4 text-[#333333] text-lg">Loading perfect socks...</p>
        </div>
      ) : (
        <div className="w-full max-w-7xl md:p-4 p-8">
          {filteredProducts.map((sock) => {
            const outOfStockMessage = outOfStockItems[sock._id] || '';
            const isOutOfStock = outOfStockMessage.includes('Out of stock') || outOfStockMessage.includes('Only');
            return (
              <div key={sock._id} className="flex lg:flex-row flex-col justify-center items-center bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <img src={sock.name} alt="Kotton Socks" className="w-full lg:w-1/2 h-[400px] md:h-auto object-cover" />
                <div className="flex flex-col items-center p-6 lg:w-1/2">
                  <h3 className="text-2xl font-semibold mb-4">{sock.description}</h3>
                  <h4 className="text-xl text-indigo-600 mb-6">Price: {sock.price} €</h4>
                  <div className="space-y-1 text-[#333333]">
                    <button onClick={toggleMenu} className="flex flex-row text-xl font-bold">
                      <h2>Contents</h2>
                      {isOpen ? <FaChevronUp className="animate-bounce mt-1 ml-2" /> : <FaChevronDown className="animate-bounce mt-1 ml-2" />}
                    </button>
                    {isOpen && (
                      <div className='animate-fade-in'>
                        <p>
                          Cotton socks, produced with the comfort of the feet in mind, are made of <strong>78% Cotton</strong>, <strong>21% Polyamide</strong>, and <strong>1% Elastane</strong> materials.
                        </p>
                        <p className="italic">Made in Türkiye.</p>

                        <h2 className="text-xl font-bold mt-3">Features</h2>
                        <ul className="list-disc list-inside space-y-2">
                          <li>Suitable for size <strong>40-44</strong>.</li>
                          <li>Socks are a type of short sock that ends slightly above the ankle.</li>
                          <li>It is mostly preferred inside sports shoes.</li>
                          <li>Since it is made of <strong>78% cotton</strong>, it does not cause odor or sweat on the feet.</li>
                          <li>It is soft and does not squeeze the feet.</li>
                          <li>Breathes through the feet.</li>
                          <li>The seams do not disturb; it is extremely comfortable.</li>
                        </ul>

                        <h2 className="text-xl font-bold mt-3">Washing Tips</h2>
                        <ul className="list-disc list-inside space-y-2">
                          <li>You can wash dirty socks at <strong>40°C</strong> with peace of mind.</li>
                          <li>As with any washing, it is important to wash the socks together with similar-colored laundry.</li>
                          <li>To prevent the socks from pilling for a long time, we recommend washing Cotton socks <strong>inside out</strong> in the washing machine.</li>
                        </ul>
                      </div>
                    )}
                  </div>

                  {/* Out of Stock Message */}
                  {outOfStockMessage && (
                    <p className="text-red-500 text-sm text-center mb-2">{outOfStockMessage}</p>
                  )}

                  {/* Quantity Input with Buttons */}
                  {!isOutOfStock && (
                    <div className="flex items-center justify-center my-4">
                      <button
                        onClick={() => handleQuantityChange(sock._id, Math.max(1, (quantities[sock._id] || 1) - 1))}
                        className="bg-gray-200 text-gray-700 w-8 h-8 flex items-center justify-center rounded-l-lg hover:bg-gray-300 transition-all duration-200"
                      >
                        -
                      </button>
                      <input
                        type="number"
                        id={`quantity-${sock._id}`}
                        name={`quantity-${sock._id}`}
                        min="1"
                        max="20"
                        value={quantities[sock._id] || 1}
                        onChange={(e) => handleQuantityChange(sock._id, e.target.value)}
                        className="w-16 px-2 py-1 border-t border-b border-gray-300 text-sm text-center"
                      />
                      <button
                        onClick={() => handleQuantityChange(sock._id, Math.min(20, (quantities[sock._id] || 1) + 1))}
                        className="bg-gray-200 text-gray-700 w-8 h-8 flex items-center justify-center rounded-r-lg hover:bg-gray-300 transition-all duration-200"
                      >
                        +
                      </button>
                    </div>
                  )}

                  {/* Add to Cart Button */}
                  {!isOutOfStock && (
                    <button
                      onClick={() => handleAddToCart(sock._id)}
                      className="w-full flex items-center justify-center bg-[#1A2A3A] text-white py-2 rounded-lg hover:bg-indigo-600 transition-all duration-300"
                    >
                      <img src={cart} alt="cart icon" className="w-5 h-5 mr-2" />
                      <span>Add to Cart</span>
                    </button>
                  )}

                  {/* Success Message */}
                  {successMessage && (
                    <p className="text-green-500 text-sm text-center mt-2">Item added to cart!</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Product_Detail;